const PopUp = () => {
  return (
    <div id="popup" className="ol-popup">
      <a href="#" id="popup-closer" className="ol-popup-closer"></a>
      <div id="popup-content"></div>
    </div>
  );
};

export default PopUp;
